import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    staticClass: "container-centered small",
    attrs: {
      id: "content"
    }
  }, [!_vm.resetDone && !_vm.alreadyUsedCode ? _c("div", [_c("h2", {
    staticClass: "title-margin-b"
  }, [_vm._v("Please enter your new password")]), _c("div", {
    staticClass: "mt-4 text-italic text-small"
  }, [_vm._v(" The password must be at least 8 characters, with at least a number, an upper and lower case letter ")]), _c("div", {
    staticClass: "container-centered small-2"
  }, [_c("div", [_c(VTextField, {
    staticClass: "white-append-icon",
    attrs: {
      label: "New password",
      type: _vm.isShowPassword ? "text" : "password",
      autofocus: ""
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c("span", {
          staticClass: "cursor--pointer",
          on: {
            click: function click($event) {
              _vm.isShowPassword = !_vm.isShowPassword;
            }
          }
        }, [!_vm.isShowPassword ? _c(VIcon, [_vm._v("mdi-eye")]) : _c(VIcon, [_vm._v("mdi-eye-off")])], 1)];
      },
      proxy: true
    }], null, false, 3100851295),
    model: {
      value: _vm.input.password,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "password", $$v);
      },
      expression: "input.password"
    }
  }), _vm.passwordError.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(_vm._s(_vm.passwordError))]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    staticClass: "white-append-icon",
    attrs: {
      label: "Confirm your new password",
      type: _vm.isShowPassword ? "text" : "password"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c("span", {
          staticClass: "cursor--pointer",
          on: {
            click: function click($event) {
              _vm.isShowPassword = !_vm.isShowPassword;
            }
          }
        }, [!_vm.isShowPassword ? _c(VIcon, [_vm._v("mdi-eye")]) : _c(VIcon, [_vm._v("mdi-eye-off")])], 1)];
      },
      proxy: true
    }], null, false, 3100851295),
    model: {
      value: _vm.input.checkPassword,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "checkPassword", $$v);
      },
      expression: "input.checkPassword"
    }
  }), _vm.checkPasswordError.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.checkPasswordError) + " ")]) : _vm._e()], 1), !_vm.telCheck ? _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ["enter"],
      expression: "['enter']"
    }],
    staticClass: "dfwa-btn --with-dark-bg",
    attrs: {
      rounded: true,
      loading: _vm.isReseting
    },
    on: {
      click: function click($event) {
        return _vm.sendTelCheck();
      }
    },
    nativeOn: {
      shortkey: function shortkey($event) {
        return _vm.sendTelCheck();
      }
    }
  }, [_vm._v(" SAVE MY PASSWORD ")])], 1) : _vm._e(), _vm.smsCheckActive() ? _c("div", [_c("h1", {
    staticClass: "title-margin-b"
  }, [_vm._v("One last step !")]), _c("label", [_vm._v("Please enter the verification code you just received by SMS")]), _c("div", [_c(VTextField, {
    attrs: {
      label: "Verification code"
    },
    model: {
      value: _vm.input.telCheckCode,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "telCheckCode", $$v);
      },
      expression: "input.telCheckCode"
    }
  }), _vm.telCheckError.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(_vm._s(_vm.telCheckError))]) : _vm._e()], 1), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ["enter"],
      expression: "['enter']"
    }],
    staticClass: "dfwa-btn --with-dark-bg",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.reset();
      }
    },
    nativeOn: {
      shortkey: function shortkey($event) {
        return _vm.reset();
      }
    }
  }, [_vm._v(" CHECK CODE ")])], 1)]) : _vm._e()])]) : _vm._e(), _vm.resetDone && !_vm.serverError && !_vm.alreadyUsedCode ? _c("div", [_c("h1", {
    staticClass: "title-margin-b"
  }, [_vm._v("Password changed")]), _c("div", [_vm._v(" Your password has been updated, you can use it right now to sign in to your account. ")]), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --with-dark-bg",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.login();
      }
    }
  }, [_vm._v("SIGN IN")])], 1)]) : _vm._e(), _vm.alreadyUsedCode ? _c("div", [_c("h2", {
    staticClass: "title-margin-b"
  }, [_vm._v("Reset already made !")]), _c("label", [_vm._v(" This request has already been fulfilled. If you do not remember your password, please use this link to "), _c("br"), _c("a", {
    on: {
      click: function click($event) {
        return _vm.resetPassword();
      }
    }
  }, [_vm._v("reset your password")])]), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --with-dark-bg",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.home();
      }
    }
  }, [_vm._v("HOME")])], 1)]) : _vm._e(), _vm.resetDone && _vm.serverError ? _c("div", [_c("h1", [_vm._v("Error")]), _c("label", [_vm._v("An error has occured, please try again later.")]), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --with-dark-bg",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.home();
      }
    }
  }, [_vm._v("HOME")])], 1)]) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };